import React, { useEffect, useState } from 'react';
import { CircleDrawIcon, HandIcon, PolygonDrawIcon } from 'assets/icons';

interface CustomDrawingControlsProps {
  drawingManager: google.maps.drawing.DrawingManager | null;
}

const CustomDrawingControls: React.FC<CustomDrawingControlsProps> = ({ drawingManager }) => {
  const [activeMode, setActiveMode] = useState<google.maps.drawing.OverlayType | null>(null);

  useEffect(() => {
    if (drawingManager) {
      // Set default mode to null (pan mode)
      drawingManager.setDrawingMode(null);

      // Listen for drawing mode changes
      const modeChangeListener = google.maps.event.addListener(drawingManager, 'drawingmode_changed', () => {
        setActiveMode(drawingManager.getDrawingMode());
      });

      return () => {
        google.maps.event.removeListener(modeChangeListener);
      };
    }
  }, [drawingManager]);

  const handleModeChange = (mode: google.maps.drawing.OverlayType | null) => {
    if (drawingManager) {
      drawingManager.setDrawingMode(mode);
      setActiveMode(mode);
    }
  };

  return (
    <div className="flex gap-1 overflow-hidden p-2">
      <div
        className={`cursor-pointer rounded-sm border bg-white p-2 hover:border-secondary ${
          activeMode === null ? 'border-secondary' : 'border-borderGray'
        }`}
        onClick={() => handleModeChange(null)}>
        <HandIcon className={`path path-fill-current ${activeMode === null ? 'text-secondary' : ''}`} />
      </div>
      <div
        className={`cursor-pointer rounded-sm border bg-white p-2 hover:border-secondary ${
          activeMode === google.maps.drawing.OverlayType.POLYGON ? 'border-secondary' : 'border-borderGray'
        }`}
        onClick={() =>
          handleModeChange(
            activeMode === google.maps.drawing.OverlayType.POLYGON ? null : google.maps.drawing.OverlayType.POLYGON
          )
        }>
        <PolygonDrawIcon
          className={`path path-fill-current ${
            activeMode === google.maps.drawing.OverlayType.POLYGON ? 'text-secondary' : ''
          }`}
        />
      </div>
      <div
        className={`cursor-pointer rounded-sm border bg-white p-2 hover:border-secondary ${
          activeMode === google.maps.drawing.OverlayType.CIRCLE ? 'border-secondary' : 'border-borderGray'
        }`}
        onClick={() =>
          handleModeChange(
            activeMode === google.maps.drawing.OverlayType.CIRCLE ? null : google.maps.drawing.OverlayType.CIRCLE
          )
        }>
        <CircleDrawIcon
          className={`path path-fill-current ${
            activeMode === google.maps.drawing.OverlayType.CIRCLE ? 'text-secondary' : ''
          }`}
        />
      </div>
    </div>
  );
};

export default CustomDrawingControls;
